import React from 'react';

import { internalLinkClickEvent } from 'analytics/events/studio';

import { getSanityLinkUrl } from 'shared/utils/getSanityLinkUrl';
import { useLocale } from 'shared/hooks/useLocale';

import { FooterLinkType } from 'types/studio/footer';

import FooterMenuLink from '../FooterMenuLink/FooterMenuLink';
import styles from './styles.module.scss';
import { useFooterContext } from '../FooterContext';

const FooterBottomMenu = () => {
  const locale = useLocale();
  const {
    data: { bottomMenuLinks: links }
  } = useFooterContext();

  const sendClickEvent = (link: FooterLinkType, label: string) =>
    internalLinkClickEvent({
      location: 'footer',
      clickText: label,
      url: getSanityLinkUrl(link, locale) || undefined
    });

  return (
    <ul className={styles.list}>
      {links
        .filter(({ link }) => !!link)
        .map((item) => (
          <li
            key={item.label}
            className={styles.item}
            onClick={() => sendClickEvent(item.link, item.label)}
            onKeyDown={() => sendClickEvent(item.link, item.label)}
            role="presentation">
            <FooterMenuLink {...item} />
          </li>
        ))}
    </ul>
  );
};

export default FooterBottomMenu;
